class SortHelper {
  sort(currentSortDir, currentSortType, sortType) {
    let internalCurrentSortDir;
    if(sortType === currentSortType) {
      internalCurrentSortDir = currentSortDir === `ASC` ? `DESC` : `ASC`;
    }
    return { currentSortDir: internalCurrentSortDir, currentSortType: sortType };
  }

  sortClass(activeSortType, currentSortDir, currentSortType) {
    let classString = `rin-table__th--sortable`;
    if(activeSortType === currentSortType) {
      classString += ` rin-table__th--active`;
      if(currentSortDir === `ASC`) classString += ` rin-table__th--asc`;
      else classString += ` rin-table__th--desc`;
    }
    return classString;
  }

  sortData(data, currentSortDir, currentSortType) {
    return data.sort((a, b) => {
      const modifier = currentSortDir === `ASC` ? 1 : -1;
      if(a.sort[currentSortType] < b.sort[currentSortType]) return -1 * modifier;
      if(a.sort[currentSortType] > b.sort[currentSortType]) return modifier;
      return 0;
    });
  }

  simplifiedSortData(data, currentSortDir, currentSortType) {
    return data.sort((a, b) => {
      const modifier = currentSortDir === `ASC` ? 1 : -1;
      if(a[currentSortType] < b[currentSortType]) return -1 * modifier;
      if(a[currentSortType] > b[currentSortType]) return modifier;
      return 0;
    });
  }

  simpleSortDesc(a, b) {
    if(a.revenue > b.revenue) {
      return -1;
    }
    if(a.revenue < b.revenue) {
      return 1;
    }
    return 0;
  }
}

export default new SortHelper();
